import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Snackbar from '@mui/material/Snackbar'
import Grid from '@mui/material/Grid'

import { Paragraph, Title } from 'components/shared'
import { Wrap, CloseButton, CloseSmNotice, useStyles } from './Notification.style'

import { setNotificationAction } from 'store/common/actions'

const Notification = () => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { notification } = useSelector(({ common }) => common)
  const [open, setOpen] = useState(true)

  useEffect(() => {
    setOpen(!!notification)
  }, [notification])

  const handleClose = () => {
    setOpen(false)
    dispatch(setNotificationAction(null))
  }

  if (notification?.size == 'sm') {
    return (
      <Snackbar
        anchorOrigin={notification?.anchorOrigin}
        open={open}
        onClose={handleClose}
        autoHideDuration={notification?.autoHideDuration}
        classes={{
          root: classes.root,
        }}
      >
        <div>
          <Grid container spacing={1} wrap={'nowrap'}>
            {notification?.status && (
              <Grid item>
                <svg width="16px" height="16px">
                  <use xlinkHref={`#${notification.status}`} />
                </svg>
              </Grid>
            )}
            <Grid item xs>
              <Paragraph size={'sm'}>{notification.message}</Paragraph>
            </Grid>
            <Grid item>
              <CloseSmNotice onClick={handleClose}>
                <svg width="16px" height="16px">
                  <use xlinkHref="#close" />
                </svg>
              </CloseSmNotice>
            </Grid>
          </Grid>
        </div>
      </Snackbar>
    )
  }

  return (
    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} onClose={handleClose}>
      <Wrap>
        <svg width="40px" height="40px">
          <use xlinkHref={`#${notification?.status}`} />
        </svg>
        <Title level={3}>{notification?.title}</Title>
        {notification?.message && <Paragraph dangerouslySetInnerHTML={{ __html: notification?.message }}></Paragraph>}

        <CloseButton onClick={handleClose}>
          <svg width="24px" height="24px">
            <use xlinkHref="#close" />
          </svg>
        </CloseButton>
      </Wrap>
    </Snackbar>
  )
}

export default Notification
